import axios from "axios";
import { decryptData, encryptData, getUserInfoLocal, trimData } from "../utils/utilities";
import { ENVIRONMENT } from "../utils/properties";
import { isEmpty, get as getByLodash } from "lodash";

const axiosInstance = axios.create({ baseURL: ENVIRONMENT.API_REST_BE });
const defaultHeaders = {
  Accept: "*/*",
};
// Request interceptor for API calls
axiosInstance.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosInstance.interceptors.response.use(
  (response) => {
    if (!/auth$/.test(response.config.url)) {
      const newToken = getByLodash(response.headers, "refresh-token", "");
      const localUserInfo = decryptData(localStorage.getItem("userInfo"));
      if (/login-master-users/.test(response.config.url)) {
        // If I call for user master, I set token for user master
        const localUserMaster = decryptData(localStorage.getItem("userMaster"));
        if (localUserMaster !== null) {
          localUserMaster.token = newToken;
          localStorage.setItem("userMaster", encryptData(localUserMaster));
        }
      } else if (localUserInfo !== null) {
        localUserInfo.token = newToken;
        localStorage.setItem("userInfo", encryptData(localUserInfo));
      }
    }
    return response;
  },
  async (error) => {
    if (error.response.status === 401) {
      // If api call gone in 401 after refresh token I send to login page
      localStorage.removeItem("userInfo");
      localStorage.removeItem("userMaster");
      if (
        !/reset-password/.test(error.config.url) &&
        !/change-password/.test(error.config.url) &&
        !/auth$/.test(error.config.url)
      ) {
        localStorage.clear();
        setTimeout(() => {
          window.location.href = `${ENVIRONMENT.BASE_URL}login`;
        }, 500);
      }
      return error.response;
    } else {
      if (error.response.status === 403) {
        localStorage.clear();
        window.location.href = `${ENVIRONMENT.BASE_URL}login`;
      } else {
        return error.response;
      }
    }
  }
);

export const get = async (path, obj = {}, responseType = "json") => {
  try {
    const token = getUserInfoLocal("token", /login-master-users/.test(path));

    if (token !== undefined) {
      defaultHeaders.Authorization = `Bearer ${token}`;
    }
    const queryString = Object.keys(obj)
      .map((key) => key + "=" + obj[key])
      .join("&");
    let { data, status } = await axiosInstance.get(
      `${ENVIRONMENT.API_REST_BE}${path}${!isEmpty(queryString) ? "?" + queryString : ""}`,
      {
        headers: defaultHeaders,
        responseType,
      }
    );
    if (status !== 200 && (responseType === "arraybuffer" || responseType === "blob")) {
      return { error: true };
    }
    return data;
  } catch (error) {
    // generally, it enters here when the call goes to "failed"
    return { error: { messageCode: "ER000" } };
  }
};

export const deleteApi = async (path, obj = {}) => {
  try {
    const token = getUserInfoLocal("token");
    if (token !== undefined) {
      defaultHeaders.Authorization = `Bearer ${token}`;
    }
    const queryString = Object.keys(obj)
      .map((key) => key + "=" + obj[key])
      .join("&");
    let { data } = await axiosInstance.delete(
      `${ENVIRONMENT.API_REST_BE}${path}${!isEmpty(queryString) ? "?" + queryString : ""}`,
      {
        headers: defaultHeaders,
      }
    );
    return data;
  } catch (error) {
    // generally, it enters here when the call goes to "failed"
    return { error: { messageCode: "ER000" } };
  }
};

export const post = async (path, obj = {}) => {
  try {
    const token = getUserInfoLocal("token", /change-user/.test(path));
    if (token !== null && !/auth$/.test(path)) {
      defaultHeaders.Authorization = `Bearer ${token}`;
    } else {
      delete defaultHeaders.Authorization;
    }
    let { data } = await axiosInstance.post(ENVIRONMENT.API_REST_BE + path, trimData(obj), {
      headers: defaultHeaders,
    });
    return data;
  } catch (error) {
    // generally, it enters here when the call goes to "failed"
    return { error: { messageCode: "ER000" } };
  }
};

export default axiosInstance;
